<template>
  <div class="flex flex-col gap-2">
    <SurveyStartDateForm
      v-model="nextOccurrenceAt"
      class="rounded-large overflow-hidden"
      :label="$t('survey.nextOccurrenceAt')"
      :min-date="minDate"
    />
    <p v-if="nextOccurrenceAtError" class="text-error text-body-small px-1">
      {{ nextOccurrenceAtError }}
    </p>
    <SurveyRecurrenceForm
      v-if="nextOccurrenceAt"
      v-model:is-recurring="isRecurring"
      v-model:recurrence-interval="recurrenceInterval"
      v-model:recurrence-frequency="recurrenceFrequency"
      v-model:start-date="nextOccurrenceAt"
      :show-start-date="false"
      :recurrence-interval-error="recurrenceIntervalError"
    />
  </div>
</template>

<script setup lang="ts">
  import { watch } from 'vue'
  import SurveyRecurrenceForm from '@/modules/start-survey/components/SurveyRecurrenceForm.vue'
  import SurveyStartDateForm from '@/modules/start-survey/components/SurveyStartDateForm.vue'
  import type { SurveyRecurrenceFrequency } from '@/modules/start-survey/composables/use-start-survey'

  interface Props {
    recurrenceIntervalError?: string
    nextOccurrenceAtError?: string
    minDate?: Date
  }

  defineProps<Props>()

  const isRecurring = defineModel<boolean>('isRecurring', { required: true })
  const nextOccurrenceAt = defineModel<Date | undefined>('nextOccurrenceAt', { required: true })
  const recurrenceInterval = defineModel<number | undefined>('recurrenceInterval', {
    required: true,
  })
  const recurrenceFrequency = defineModel<SurveyRecurrenceFrequency | undefined>(
    'recurrenceFrequency',
    { required: true },
  )

  watch(nextOccurrenceAt, (date) => {
    if (!date) {
      isRecurring.value = false
    }
  })
</script>
